module.exports = __webpack_public_path__ + "img/1716360251684-WhatsApp Image 2024-05-22 at 14.25.44.jpeg.ee49fb17.webp";